import { Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/providers/AuthProvider';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { ThemeProvider } from '@/providers/ThemeProvider';

// Pages
import { LandingPage } from '@/pages/LandingPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { ForgotPasswordPage } from '@/pages/auth/ForgotPasswordPage';
import { GoogleCallback } from '@/pages/auth/GoogleCallback';
import { GitHubCallback } from '@/pages/auth/GitHubCallback';
import { LogoutPage } from '@/pages/auth/LogoutPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { ProfilesPage } from '@/pages/profile/ProfilesPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { InterviewPage } from '@/pages/interview/InterviewPage';
import { BillingPage } from '@/pages/billing/BillingPage';
import { ImprovedOnboardingPage } from '@/pages/onboarding/ImprovedOnboardingPage';
import { TermsPage } from '@/pages/static/TermsPage';
import { PrivacyPage } from '@/pages/static/PrivacyPage';
import { CookiesPage } from '@/pages/static/CookiesPage';
import { AboutPage } from '@/pages/static/AboutPage';
import { BlogPage } from '@/pages/static/BlogPage';
import { ProductPage } from '@/pages/static/ProductPage';
import { ChangelogPage } from '@/pages/static/ChangelogPage';
import { DemoPage } from '@/pages/static/DemoPage';

function App() {
 return (
  <ThemeProvider defaultTheme='dark' storageKey='vite-ui-theme'>
   <AuthProvider>
    <div className='min-h-screen bg-background'>
     <Routes>
      {/* Public routes */}
      <Route path='/' element={<LandingPage />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/register' element={<RegisterPage />} />
      <Route path='/forgot-password' element={<ForgotPasswordPage />} />
      <Route path='/auth/google/callback' element={<GoogleCallback />} />
      <Route path='/auth/github/callback' element={<GitHubCallback />} />
      <Route path='/logout' element={<LogoutPage />} />

      {/* Static Pages */}
      <Route path='/terms' element={<TermsPage />} />
      <Route path='/privacy' element={<PrivacyPage />} />
      <Route path='/cookies' element={<CookiesPage />} />
      <Route path='/about' element={<AboutPage />} />
      <Route path='/blog' element={<BlogPage />} />
      <Route path='/product' element={<ProductPage />} />
      <Route path='/changelog' element={<ChangelogPage />} />
      <Route path='/demo' element={<DemoPage />} />

      {/* Protected routes */}
      <Route
       path='/onboarding'
       element={
        <ProtectedRoute>
         <ImprovedOnboardingPage />
        </ProtectedRoute>
       }
      />
      <Route
       path='/dashboard'
       element={
        <ProtectedRoute>
         <DashboardPage />
        </ProtectedRoute>
       }
      />
      <Route
       path='/profile'
       element={
        <ProtectedRoute>
         <ProfilePage />
        </ProtectedRoute>
       }
      />
      <Route
       path='/settings'
       element={
        <ProtectedRoute>
         <SettingsPage />
        </ProtectedRoute>
       }
      />
      <Route
       path='/profiles'
       element={
        <ProtectedRoute>
         <ProfilesPage />
        </ProtectedRoute>
       }
      />
      <Route
       path='/interview/:sessionId?'
       element={
        <ProtectedRoute>
         <InterviewPage />
        </ProtectedRoute>
       }
      />
      <Route
       path='/billing'
       element={
        <ProtectedRoute>
         <BillingPage />
        </ProtectedRoute>
       }
      />
     </Routes>
     <Toaster />
    </div>
   </AuthProvider>
  </ThemeProvider>
 );
}

export default App;
